import { Autocomplete, TextField } from "@mui/material"
import { translate } from "app/language/service"
import { getAllMediaApprovalStatuses, MEDIA_APPROVAL_STATUSES } from "media/model"
import React from "react"

interface IStatusFilterProps {
  id: string
  label: string
  value: MEDIA_APPROVAL_STATUSES[]
  sx?: any
  onChange(newValue: MEDIA_APPROVAL_STATUSES[]): any
}

export const StatusFilter = React.memo(({ id, label, value, onChange, sx }: IStatusFilterProps): JSX.Element => {
  const options = getAllMediaApprovalStatuses()
  return (
    <Autocomplete
      multiple
      sx={{ ...sx }}
      id={id}
      size="small"
      options={options}
      getOptionLabel={option => translate(`media.creatives.status.${option}`)}
      value={value}
      filterSelectedOptions
      onChange={(_event, newValue) => onChange(newValue)}
      renderInput={params => <TextField {...params} label={label} />}
    />
  )
})
